import {NSFunctions} from './utils/functions'
import {xCore} from './core';
import { NSUserFunctionPermissions } from './user_function_permissions'
import { NSExport } from './export';
import { NSPrint } from './print';

import LayersIcon from 'bootstrap-icons/icons/layers-fill.svg?raw';
import FileEarmarkIcon from 'bootstrap-icons/icons/file-earmark-fill.svg?raw';
import PrinterIcon from 'bootstrap-icons/icons/printer-fill.svg?raw';
import CloudDownloadIcon from 'bootstrap-icons/icons/cloud-download-fill.svg?raw';
import { NSPageLabels } from './page_labels';

export let NSPageSidepanel = {};

NSPageSidepanel.init = function ()
{
    NSPageSidepanelPrivate.init();
	
	this.f_enable_editortool = 	    function () { return NSPageSidepanelPrivate.f_enable_editortool.apply( NSPageSidepanelPrivate, arguments ); };
	this.f_sidepanel_is_visible =	function () { return NSPageSidepanelPrivate.f_sidepanel_is_visible.apply( NSPageSidepanelPrivate, arguments ); };
	this.f_show_sidepanel = 	    function () { return NSPageSidepanelPrivate.f_show_sidepanel.apply( NSPageSidepanelPrivate, arguments ); };
	this.f_hide_sidepanel = 	    function () { return NSPageSidepanelPrivate.f_hide_sidepanel.apply( NSPageSidepanelPrivate, arguments ); };
	
	window.NSPageSidepanel_ = NSPageSidepanel;
}

let NSPageSidepanelPrivate = 
{
	CONSTS: {
		TABS_LI_ID: {
			layer: "layertool",
			editor: "editortool",
			print: "printtool",
			export: "exporttool",
			pdm: "pdmtool",			
		}
	},
	
	private_objs: {
		s_e_div_sidepanel_holder_id: "sidepanel",
		e_div_sidepanel_holder: null
	},
	
	init: function()
	{
		var e_div_sidepanel_holder = document.getElementById(this.private_objs.s_e_div_sidepanel_holder_id);
		this.private_objs.e_div_sidepanel_holder = e_div_sidepanel_holder;
		
		this.f_create();
		
		this.initInterface();
		this.f_init_listners();	
	},
	
	initInterface: function() {
		document.getElementById(xCore.state.interface.sidepanel.activetool).querySelector('a.nav-link').classList.add("active");
		document.getElementById(xCore.state.interface.sidepanel.activepage).classList.add("active");

		//Start sidepanel closed
		this.private_objs.e_div_sidepanel_holder.classList.add('collapsed');
		
		//Sidepanel expand button:
		var e_side_tab = document.getElementById("sidepanel-expand-button");
		e_side_tab.innerHTML = 
		`<div class="expand-button left">
			<div class="direction-arrow-container">
				<div class="direction-arrow"></div>
			</div>
			<div class="separator"></div>
			<div class="stripes-container">
				<div class="stripe"></div>
				<div class="stripe"></div>
				<div class="stripe"></div>
			</div>
		</div>`;

		this.f_refresh_expand_button_icon();
	},
	
	f_init_listners: function()
	{
		var this_ = this;

		//Sidetab Drawer toggle
		document.getElementById("sidepanel-expand-button").onclick = () => {
			this.private_objs.e_div_sidepanel_holder.classList.toggle('collapsed');
			
			this.f_refresh_expand_button_icon();
		}; 
		
		
		//sidepanel tabs
		document.querySelectorAll("#sidetoolbar > li").forEach(element => 
        {
            element.onclick = function ( event ){
                //on tab exit
                var e_li_active = this_.f_get_active_li_elem()

                if(e_li_active.id == this_.CONSTS.TABS_LI_ID.print)
                {
                    NSPrint.f_hide();
                }
                
				let currentTarget = event ? event.currentTarget: this;
                
                //Change the tab
				document.querySelectorAll("#sidetoolbar > li.nav-item > a.nav-link.active").forEach(element => element.classList.remove('active'));

                currentTarget.querySelector('a.nav-link').classList.add('active');
                
                //on tab enter
                e_li_active = this_.f_get_active_li_elem()
                if(e_li_active.id == this_.CONSTS.TABS_LI_ID.print)
                {
                    NSPrint.f_show();
                }
                
                //remove all pages visibility
				document.querySelectorAll(".sidepanel-page").forEach((element) => { element.classList.remove("active"); } );
                
				//Change visibility of right page
                var page = currentTarget.children[0].getAttribute("page");
				
				document.querySelector(`#${page}.sidepanel-page`).classList.add("active");
				
				if(page == "exportpage")
				{
					NSExport.f_show();
				}
                
                //updates states
                xCore.state.interface.sidepanel.activetool = currentTarget.id;
                xCore.state.interface.sidepanel.activepage = page;
            }
        });
        
		
	},

	f_refresh_expand_button_icon: function()
	{
		var s_title_side_tab;
		var e_tab = document.querySelector("#sidepanel-expand-button .expand-button");
		var b_sidepanel_is_visible = this.f_sidepanel_is_visible();
		if(b_sidepanel_is_visible)
		{
            e_tab.classList.remove("left");
            e_tab.classList.add("right", "secondary");
			s_title_side_tab = NSPageLabels.f_get_label_text_by_internal_name('common_collapse');
		}
		else
		{
            e_tab.classList.add("left");
            e_tab.classList.remove("right", "secondary");
			s_title_side_tab = NSPageLabels.f_get_label_text_by_internal_name('common_expand');
		}
		
        e_tab.setAttribute("title", s_title_side_tab);
	},
	
	f_create: function()
	{
		let a_tabs = [
			{key: 'layertool', title: NSPageLabels.f_get_label_text_by_internal_name('sidepanel_layertool_tab_tooltip'), icon: LayersIcon, page: 'layerpage'},
			{key: 'editortool', title: NSPageLabels.f_get_label_text_by_internal_name('sidepanel_editortool_tab_tooltip'), icon: FileEarmarkIcon, page: 'editorpage'},
			{key: 'printtool', title: NSPageLabels.f_get_label_text_by_internal_name('sidepanel_printtool_tab_tooltip'), icon: PrinterIcon, page: 'printpage'},
			{key: 'exporttool', title: NSPageLabels.f_get_label_text_by_internal_name('sidepanel_exporttool_tab_tooltip'), icon: CloudDownloadIcon, page: 'exportpage'},
			{key: 'pdmtool', title: NSPageLabels.f_get_label_text_by_internal_name('sidepanel_pdmtool_tab_tooltip'), short_title: 'PDM', page: 'pdmpage'},
		]
		
		let a_tabs_elements_string = [];

		for (let [i, a_tab] of a_tabs.entries()) {
			a_tabs_elements_string.push(
				`<li id="${a_tab.key}" class="nav-item" role="presentation" title="${a_tab.title || ''}">
					<a class="nav-link ${i === 0 ? 'active' : ''}" page="${a_tab.page}">
						${a_tab.icon ? a_tab.icon : a_tab.short_title}
					</a>
				</li>`
			)
		}

		var private_objs = this.private_objs;

		var s_html = `
			<div id="sidepanel-expand-button"></div>
			<div id="sidepanel-content-container">
				<div id="sidepanel-content-header">
					<ul id="sidetoolbar" class="nav nav-tabs nav-fill nav-justify">
						${a_tabs_elements_string.join('\n')}
					</ul>
				</div>
				<div id="sidepanel-content-header-mini-mode">
					<div id="sidepanel-content-buttons" class="btn-group btn-group-sm"> 
						<button id="sidepanel-close-button" type="button" class="btn btn-sm btn-outline-secondary" title="Fechar"><img src="${xCore.application.images_base_path}/common/chevron-left_red.svg" width="16" height="16"></button>
					</div>
				</div>
				<div id="sidepanel-content-pages">
					<div id="layerpage" class="sidepanel-page">
						<div id="layerpage_content" class="page-content"></div>
					</div>		  
					<div id="editorpage" class="sidepanel-page">
						<div id="editorpage_read" class="page-content"></div>
						<div id="editorpage_edit" class="page-content"></div>
						<div id="editorpage_coordinates" class="page-footer"></div>
					</div>
					<div id="printpage" class="sidepanel-page"></div>
					<div id="exportpage" class="sidepanel-page"></div>
					<div id="pdmpage" class="sidepanel-page"></div>
				</div>
			</div>
		`;
				
		var e_div_sidepanel_holder = private_objs.e_div_sidepanel_holder;
		e_div_sidepanel_holder.innerHTML = "";
		NSFunctions.f_dom_elem_append_dom_childs_by_html(e_div_sidepanel_holder, s_html);

		e_div_sidepanel_holder.querySelector('#sidepanel-close-button').onclick = () => { this.f_hide_sidepanel(); };
		
		this.f_set_sidepanel_visibility();
	},
	f_set_sidepanel_visibility: function()
	{
		var e_;
		var b_has_permissions;
		
		/*
		TABS_LI_ID: {
				layer: "layertool",
				editor: "editortool",
				print: "printtool",
				export: "exporttool",
				pdm: "pdmtool",			
			}
		*/
		e_ = document.getElementById(this.CONSTS.TABS_LI_ID.layer);
		b_has_permissions = true;
		this.f_set_element_display_(e_, b_has_permissions);
		
		e_ = document.getElementById(this.CONSTS.TABS_LI_ID.editor);
		b_has_permissions = NSUserFunctionPermissions.f_has_function_type_UPDATE();
		this.f_set_element_display_(e_, b_has_permissions);
		
       
		e_ = document.getElementById(this.CONSTS.TABS_LI_ID.print);
		b_has_permissions = NSUserFunctionPermissions.f_has_function_type_READ();
		this.f_set_element_display_(e_, b_has_permissions);
		
		e_ = document.getElementById(this.CONSTS.TABS_LI_ID.export);
		b_has_permissions = NSUserFunctionPermissions.f_has_function_type_READ();
		this.f_set_element_display_(e_, b_has_permissions);
		
		e_ = document.getElementById(this.CONSTS.TABS_LI_ID.pdm);
		b_has_permissions =  NSUserFunctionPermissions.f_has_function_type_READ();
		this.f_set_element_display_(e_, b_has_permissions);
		
	},
	f_set_element_display_: function(e_, b_display)
	{	
		e_.style.display = b_display ? "" : "none";
	},
	f_enable_layertool: function()
	{
		document.getElementById("layertool").onclick();
	},
	f_enable_editortool: function()
	{
		document.getElementById("editortool").onclick();
	},
	f_enable_printtool: function()
	{
		document.getElementById("printtool").onclick();
	},
	f_enable_exporttool: function()
	{
		document.getElementById("exporttool").onclick();
	},
	f_enable_pdmtool: function()
	{
		document.getElementById("pdmtool").onclick();
	},
	
	f_sidepanel_is_visible: function()
	{
		return !this.private_objs.e_div_sidepanel_holder.classList.contains('collapsed');
	},
	f_show_sidepanel: function()
	{
		var b_sidepanel_is_visible = this.f_sidepanel_is_visible();
		
		if(!b_sidepanel_is_visible)
		{
			this.private_objs.e_div_sidepanel_holder.classList.remove('collapsed')
		}
		
		this.f_refresh_expand_button_icon();
	},
	f_hide_sidepanel: function()
	{
		var b_sidepanel_is_visible = this.f_sidepanel_is_visible();

		if(b_sidepanel_is_visible)
		{				
			this.private_objs.e_div_sidepanel_holder.classList.add('collapsed')
		}
		
		this.f_refresh_expand_button_icon();
	},
	
	//returns active tab (document element li )
	f_get_active_li_elem: function()
	{
		var e_li_active = document.querySelector("#sidetoolbar > li.nav-item > a.nav-link.active");
		return e_li_active.parentElement;
	}
}